import type { FC, ReactNode } from 'react'

import { useState } from 'react'
import Link from 'next/link'

export const Cart: FC = (): ReactNode => {
    const [open, setOpen] = useState(false)

    return (
        <div className='w-commerce-commercecartwrapper cart'>
            <a
                href='#'
                role='button'
                aria-haspopup='dialog'
                aria-label='باز کردن سبد خرید'
                onClick={(event) => {
                    event.preventDefault()
                    setOpen(true)
                }}
                className='w-commerce-commercecartopenlink cart-button w-inline-block'
            >
                <img src='/images/Cart-Icon.svg' loading='lazy' alt='' className='cart-icon' />
                <div className='w-commerce-commercecartopenlinkcount cart-quantity'>0</div>
            </a>

            <div
                style={{ display: open ? 'flex' : 'none' }}
                className='w-commerce-commercecartcontainerwrapper w-commerce-commercecartcontainerwrapper--cartType-rightDropdown cart-wrapper'
            >
                <div role='dialog' className='w-commerce-commercecartcontainer cart-container'>
                    <div className='w-commerce-commercecartheader cart-header'>
                        <h6 className='w-commerce-commercecartheading white-text'>سبد خرید</h6>
                        <a
                            href='#'
                            role='button'
                            aria-label='بستن سبد خرید'
                            onClick={(event) => {
                                event.preventDefault()
                                setOpen(false)
                            }}
                            className='w-commerce-commercecartcloselink close-button w-inline-block'
                        >
                            <img src='/images/x-3.svg' loading='lazy' alt='' className='cart-x-icon' />
                        </a>
                    </div>

                    <div className='w-commerce-commercecartformwrapper'>
                        <div className='w-commerce-commercecartemptystate empty-state'>
                            <div aria-live='polite' aria-label='سبد خرید خالی است'>سبد خرید شما هنوز خالی است.</div>
                            <Link href='/pricing' className='button w-button'>دیدن محصولات</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
